"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M20 3H4c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h4v2h8v-2h4c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2m0 14H4V5h16z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M6.5 7.5H9V6H5v4h1.5zM19 12h-1.5v2.5H15V16h4z"
}, "1")], 'ScreenshotMonitor');